import type { IAntdConfig } from '@/Core/Contracts/Configs'
import uk from 'antd/locale/uk_UA'

import { themeStore } from '@/Ship/Stores/ThemeStore'
import { getAntdTheme } from './ThemeConfig'

/**
 * Конфігурація Antd, яку читає Core Layout (ConfigProvider {...AntdConfig}).
 * Самі токени живуть у ThemeConfig.ts.
 *
 * `theme` є геттером: Core розгортає конфіг при кожному рендері свого
 * LayoutWrapper, а Root у main.tsx (observer ThemeStore) перерендерює дерево
 * при перемиканні, тож поточна тема доходить і до Core-компонентів поза
 * DefaultLayout (ResourceCardRenderer, дровери CRUD). Core DatePickerInput
 * читає геттер один раз при завантаженні модуля й лишається темним.
 */
export const AntdConfig: IAntdConfig = {
    /** Щільніші компоненти (32px замість 40px) */
    componentSize: 'middle',
    get theme() {
        return getAntdTheme(themeStore.mode)
    },
    /** Базова локаль за замовчуванням */
    locale: uk,
}
